import { render, staticRenderFns } from "./ProgramSponsorDetails.vue?vue&type=template&id=67d10c96&scoped=true&"
import script from "./ProgramSponsorDetails.vue?vue&type=script&lang=js&"
export * from "./ProgramSponsorDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSponsorDetails.vue?vue&type=style&index=0&id=67d10c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d10c96",
  null
  
)

export default component.exports